import React, { useEffect, useState } from "react";
import Profile from "./components/Profile";
import { useParams } from "react-router-dom";
import Company from "./components/Company";
import Properties from "./components/Properties";
import Cleaners from "./components/Cleaners";
import LodgifyConnection from "./components/LodgifyConnection";
import { removeAccessToken, removeRefreshToken } from "../../storage/storage";
import { useLocation, useNavigate } from "react-router-dom";
import { GoOrganization } from "react-icons/go";
import { FiHome, FiUser, FiUsers, FiLink } from "react-icons/fi";

const Settings = () => {
  const { currentTab } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState(currentTab);

  useEffect(() => {
    setActiveTab(currentTab);
  }, [currentTab]);

  const handleLogout = () => {
    removeAccessToken();
    removeRefreshToken();
    window.location.href = "/login";
  };

  const tabs = [
    { id: "profile", label: "Profile", icon: <FiUser />, path: "/settings/profile" },
    { id: "company", label: "Company", icon: <GoOrganization />, path: "/settings/company" },
    { id: "properties", label: "Properties", icon: <FiHome />, path: "/settings/properties" },
    { id: "cleaners", label: "Cleaners", icon: <FiUsers />, path: "/settings/cleaners" },
    { id: "lodgify", label: "Channel Manager Config", icon: <FiLink />, path: "/settings/lodgify" },
  ];

  const handleTabClick = (tabId) => {
    setActiveTab(tabId);
    navigate(`/settings/${tabId.toLowerCase()}`);
  };

  return (
    <div className="min-h-screen bg-[#F9F9F9] p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="bg-white rounded-2xl shadow-sm p-6 mb-6">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between">
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-[#586989] mb-2">
                Settings
              </h1>
              <p className="text-gray-600">
                Manage your account settings and preferences
              </p>
            </div>
            <button
              onClick={handleLogout}
              className="mt-4 md:mt-0 bg-[#586989] text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:bg-[#47546d] transition-colors"
            >
              Logout
            </button>
          </div>
        </div>

        {/* Tab Navigation */}
        <div className="bg-white rounded-2xl shadow-sm p-1 mb-6">
          <div className="flex overflow-x-auto">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => handleTabClick(tab.id)}
                className={`
                  flex items-center justify-center gap-2 px-4 py-3 rounded-lg flex-shrink-0 transition-all duration-200
                  ${activeTab === tab.id
                    ? "bg-[#FFF5CE] text-[#586989] font-semibold shadow-sm"
                    : "text-gray-600 hover:text-[#586989] hover:bg-gray-50"
                  }
                `}
              >
                <span className="text-lg">{tab.icon}</span>
                <span className="text-sm font-medium whitespace-nowrap">
                  {tab.label}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="bg-white rounded-2xl shadow-sm p-6">
          {activeTab === "profile" && <Profile />}
          {activeTab === "company" && <Company />}
          {activeTab === "properties" && <Properties />}
          {activeTab === "cleaners" && <Cleaners />}
          {activeTab === "lodgify" && <LodgifyConnection />}
        </div>
      </div>
    </div>
  );
};

export default Settings;